import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-deeplink-button',
  templateUrl: './deeplink-button.component.html',
  styleUrls: ['./deeplink-button.component.scss'],
})
export class DeeplinkButtonComponent implements OnInit {
  @Input() text!: string;
  @Input() loading = false;
  @Input() fullWidth!: boolean;
  @Input() icon: 'mobile-bank-id-icon' | 'idin-icon' | 'none' = 'mobile-bank-id-icon';
  @Input() disabled = false;
  @Output() buttonClicked = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  getClass(): any {
    return { [this.icon]: !this.loading, loader: this.loading };
  }

  onClick(): void {
    if (this.loading) {
      return;
    }
    this.buttonClicked.emit();
  }
}
